import { render, staticRenderFns } from "./ExternalExaminerAuth.vue?vue&type=template&id=1b80df4c&scoped=true"
import script from "./ExternalExaminerAuth.vue?vue&type=script&lang=js"
export * from "./ExternalExaminerAuth.vue?vue&type=script&lang=js"
import style0 from "./ExternalExaminerAuth.vue?vue&type=style&index=0&id=1b80df4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80df4c",
  null
  
)

export default component.exports